/* eslint-disable no-unused-vars */

import {
  Badge,
  Button,
  Collapse,
  ListItem,
  Typography
} from '@mui/material';
import React, { useContext, useState } from 'react';

import ExpandLessTwoToneIcon from '@mui/icons-material/ExpandLessTwoTone';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import MenuIcon from './MenuIcon';
import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
import { SidebarContext } from '../../../../contexts/SidebarContext';
import clsx from 'clsx';

const SidebarMenuItem = ({
  children,
  link,
  icon: Icon,
  image,
  hoverImage,
  selectedImage,
  badge,
  open: openParent,
  active,
  name,
  ...rest
}) => {
  const [menuToggle, setMenuToggle] = useState(openParent);
  const { closeSidebar } = useContext(SidebarContext);
  const [isButtonHover, setIsButtonHover] = useState(false)

  const toggleMenu = () => {
    setMenuToggle((Open) => !Open);
  };

  if (children) {
    return (
      <ListItem component="div" className="Mui-children" key={name} {...rest} >
        <Button
          className={clsx({ 'Mui-active': active })}
          startIcon={Icon && <Icon />}
          endIcon={
            menuToggle ? <ExpandLessTwoToneIcon /> : <ExpandMoreTwoToneIcon />
          }
          onClick={toggleMenu}
        >
          {name}
        </Button>
        <Collapse in={menuToggle}>{children}</Collapse>
      </ListItem>
    );
  }
  return (
    <>
      <ListItem component="div" key={name} {...rest} >
        {name == 'Management' ? (
          <Button
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              fontFamily: 'lato'
            }}
            className={clsx({ 'Mui-active': active })}
            disableRipple
            component={RouterLink}
            onClick= {closeSidebar}
            onMouseOver = {()=>setIsButtonHover(true)}
            onMouseOut = {()=>setIsButtonHover(false)}
            to={link}
          >
            <Icon sx={{ padding: '0px 0px 5px 15px', fontSize: '30px' }} >
              <MenuIcon
                defaultIcon={image}
                selected={selectedImage}
                hover={hoverImage}
                isSelected={active}
                isButtonHover = {isButtonHover}
              />
            </Icon>
            <Typography
              sx={{
                fontFamily: 'Lato',
                fontStyle: 'normal',
                fontSize: '12px',
                fontWeight: 400,
                display: "flex",
                alignItems: 'center',
                lineHeight: '16px',
                letterSpacing: '0.32px',
                textAlign: 'center',
              }}
            >
              {name}
              </Typography>
            {badge && <Badge badgeContent={badge} />}
          </Button>
        ) : (
          <Button
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              fontFamily: 'lato',
              height: '90px'
            }}
            className={clsx({ 'Mui-active': active })}
            disableRipple
            component={RouterLink}
            onClick={closeSidebar}
            onMouseOver = {()=> setIsButtonHover(true)}
            onMouseOut={()=>setIsButtonHover(false)}
            to={link}
          >
            <Icon sx={{ padding: '0px 0px 5px 15px', fontSize: '30px' }}>
              <MenuIcon
                defaultIcon={image}
                selected={selectedImage}
                hover={hoverImage}
                isSelected={active}
                isButtonHover = {isButtonHover}
              />
            </Icon>
            <Typography
              sx={{
                fontFamily: 'Lato',
                fontStyle: 'normal',
                fontSize: '12px',
                fontWeight: 400,
                display: "flex",
                alignItems: 'center',
                lineHeight: '16px',
                letterSpacing: '0.32px',
                textAlign: 'center',
              }}
            >
              {name}
              </Typography>

            {badge && <Badge badgeContent={badge} />}
          </Button>
        )}
      </ListItem>
    </>
  );
};

SidebarMenuItem.propTypes = {
  children: PropTypes.node,
  active: PropTypes.bool,
  link: PropTypes.string,
  icon: PropTypes.elementType,
  badge: PropTypes.string,
  badgeTooltip: PropTypes.string,
  open: PropTypes.bool,
  name: PropTypes.string.isRequired,
  alt: PropTypes.string,
  image: PropTypes.elementType,
  hoverImage: PropTypes.elementType,
  activeImage: PropTypes.elementType,
  selectedImage: PropTypes.elementType
};

SidebarMenuItem.defaultProps = {
  open: false,
  active: false
};

export default SidebarMenuItem;
